import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import classNames from './Playlists.css'
import { fetchPlaylists, deletePlaylist, savePlaylist, updateListOrder } from '../redux/playlists'
import { updateUser } from '../redux/users'
import { fetchAlbums } from '../redux/albums'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import EmptyNotice from '../components/EmptyNotice'
import SortableList from '../components/playlist/SortableList'
import SortableBar from '../components/playlist/SortableBar'
import { clearPlaylistEditorCache } from './PlaylistEditor'
import { createImageGetter } from '../utils/images'
import { pluralize } from '../utils/string'
import { userHasPerm } from '../utils/auth'
import { filterAlbums } from './List'
import { AUTO_PLAYLIST_SUFFIX } from '../constants'

class Playlists extends Component {
  componentDidMount () {
    const { data, fetchPlaylists, albums, fetchAlbums } = this.props
    if (!data) fetchPlaylists()
    if (!albums) fetchAlbums()

    clearPlaylistEditorCache()
  }
  deletePlaylist (playlist) {
    if (window.confirm(`Are you sure you want to delete ${playlist.name}?`)) {
      this.props.deletePlaylist(playlist.id)
    }
  }
  getCover = item => {
    const { entities, getImageSource } = this.props
    const album = entities.albums[item.album]
    if (!album) {
      return null
    }
    return (
      <div
        key={album.cover}
        className={classNames.cover}
        style={{ backgroundImage: `url(${getImageSource(album.cover, 'i')})` }}
      />
    )
  }
  getDescription (playlist) {
    const structure = JSON.parse(playlist.json_data)
    let description = pluralize(structure.albums.length, 'album')
    if (structure.playlistsOnly) {
      description += ', for playlist albums only'
    }
    if (this.props.route.playlists) {
      return (
        <div className={classNames.description}>
          {description}
          <br />
          {structure.albums.map(this.getCover)}
        </div>
      )
    }
    return description
  }
  renderPlaylist = playlist => {
    const { route, editPlaylist } = this.props
    if (route.playlists) {
      return (
        <Link to={`playlists/${playlist.id}`} className={classNames.playlist}>
          <div className={classNames.name}>
            {playlist.name}
          </div>
          {this.getDescription(playlist)}
        </Link>
      )
    }
    return (
      <SortableBar
        title={playlist.name}
        subtitle={this.getDescription(playlist)}
        onEdit={() => editPlaylist(playlist.id)}
        onRemove={() => this.deletePlaylist(playlist)}
        titleLink={`/group/${playlist.id}`}
      />
    )
  }
  renderFixedLists () {
    return (
      <div className={classNames.fixedLists}>
        {[
          { key: 'favourites', title: 'Favourite Albums' },
          { key: 'shared', title: 'Shared With Me' },
          { key: 'recent', title: 'Recent' },
          { key: 'all', title: 'All Albums' }
        ].map(list => (
          <SortableBar
            key={list.key}
            title={list.title}
            titleLink={`/group/${list.key}`}
            subtitle={pluralize(this.props.counts[list.key], 'album')}
            showHandle={false}
          />
        ))}
      </div>
    )
  }
  render () {
    const { route, data, fetching, error, fetchPlaylists, submitting } = this.props

    const thing = route.playlists ? 'playlist' : 'album group'
    const createPath = route.playlists ? '/playlists/create' : '/groups/create'

    if (error) {
      return (
        <ErrorMessage
          message={`There was an error fetching ${thing}s`}
          onRetry={fetchPlaylists}
        />
      )
    }

    if (!data || fetching) {
      return <LoadingSpinner />
    }

    if (data.length === 0) {
      return (
        <div className={classNames.page}>
          {route.playlists &&
            <EmptyNotice
              heading='Create a playlist of albums'
              text='Build a playlist from a list of albums and use them when building queues.'
            />
          }
          {!route.playlists &&
            <EmptyNotice
              heading='Create an album group'
              text='Albums can be added to groups for easy access and organisation.'
            />
          }
          <Link to={createPath} className={classNames.button} style={{ margin: '20px auto' }}>
            Create new {thing}
          </Link>
        </div>
      )
    }

    return (
      <div className={classNames.page}>
        <Link to={createPath} className={classNames.button}>
          Create new {thing}
        </Link>
        <SortableList
          items={data}
          renderItem={this.renderPlaylist}
          sortHandle='handle'
          onSort={data => this.props.updateListOrder(data.map(p => p.id))}
        />
        {!route.playlists &&
          this.renderFixedLists()
        }
        <LoadingSpinner show={submitting} />
      </div>
    )
  }
}

const mapStateToProps = ({ playlists, entities, auth, users, albums }, { route }) => {
  const denormalize = id => entities.playlists[id]
  const data = route.playlists ? playlists.playlists : playlists.lists
  function filterList (list) {
    return list.name.indexOf(AUTO_PLAYLIST_SUFFIX) === -1
  }
  return {
    entities,
    data: data && data.map(denormalize).filter(filterList),
    fetching: playlists.fetching || users.fetching,
    error: playlists.error,
    user: auth.user,
    getImageSource: createImageGetter(auth),
    albums: albums.all.data,
    submitting: playlists.submitting,
    canEditPlaylists: userHasPerm(auth.user, 'create_channels'),
    counts: {
      all: filterAlbums('all', albums, entities, auth).length,
      favourites: filterAlbums('favourites', albums, entities, auth).length,
      shared: filterAlbums('shared', albums, entities, auth).length,
      recent: filterAlbums('recent', albums, entities, auth).length
    }
  }
}

const mapDispatchToProps = (dispatch, { route }) => {
  const editPath = route.playlists ? '/playlists' : '/groups'
  return {
    ...bindActionCreators({
      fetchPlaylists,
      deletePlaylist,
      savePlaylist,
      updateUser,
      fetchAlbums,
      updateListOrder
    }, dispatch),
    editPlaylist: id => dispatch(push(`${editPath}/${id}`))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Playlists)



// WEBPACK FOOTER //
// ./src/pages/Playlists.js